import React, { useState, useEffect } from 'react';

const PDFViewer = ({ pdfData, isLoading, setIsLoading }) => {
  
  
  useEffect(() => {
    // Reset loading state when pdfData changes
    if (pdfData) {
      setIsLoading(true);
    }
  }, [pdfData]);

  if (!pdfData) return <div className="pdf-viewer empty">No PDF loaded.</div>;
  
  return (
    <div className="pdf-viewer">
      {isLoading && <div className="pdf-loading">Loading PDF...</div>}
      <iframe 
        src={`data:application/pdf;base64,${pdfData}`}
        title="Resume Preview"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          overflow: 'auto',
          display: isLoading ? 'none' : 'block' // Hide iframe while loading
        }}
        frameBorder="0"
        onLoad={() => setIsLoading(false)} // Set loading to false when iframe loads
      />
    </div>
  );
};

export default PDFViewer;